<template>
  <div>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>類型</th>
        <th>值</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td class="text-center">
          <a class="btn btn-primary" href="#" @click="submit(item)"><i class="fa fa-save"></i></a>
        </td>
        <td >
          {{item.title}}
        </td>
        <td >
          <div v-if="item.uitype==='text'">
            <input type="text" class="form-control" placeholder="" v-model="item.value">
          </div>
          <div v-if="item.uitype==='textarea'">
            <textarea class="form-control" rows="5" v-model="item.value"></textarea>
          </div>
          <div v-else-if="item.uitype==='image'">
            <img :src="convertToRealUrl(item.value)" style="width:300px;height: 200px">
            <FileUploadButton :emmit-back-param="item" v-on:uploadSuccess="uploadSuccess" file-type="file" ></FileUploadButton>
          </div>
          <div v-else-if="item.uitype==='html'">
            <MyCkEditor ref="myCkEditor" v-model="item.value"  height="200" width="100%" :file-upload-list-lite_is-show="false"></MyCkEditor>
          </div>
          <div v-else>

          </div>

        </td>
      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
/**

 **/
import apiAdmin from "@/taylorCommon/apiAdmin";
import {
  SettingPage_QueryType_Index,
  SettingPage_QueryType_About,
  SettingPage_QueryType_Event,
  SettingPage_QueryType_Sign,
  SettingPage_QueryType_Ebooks,
  SettingPage_QueryType_BookingStep1,
  SettingPage_QueryType_BookingStep2,
  SettingPage_QueryType_BookingStep3,
  SettingPage_QueryType_BookingStep4,
  SettingPage_QueryType_BookingStep5,
  SettingPage_QueryType_OrderStep1,
  SettingPage_QueryType_OrderStep2,
  SettingPage_QueryType_OrderStep3,
  SettingPage_QueryType_Page_ProductList,
  SettingPage_QueryType_Page_ProductDetail,
  SettingPage_QueryType_Page_Register,
  SettingPage_QueryType_Page_Login,
  SettingPage_QueryType_Page_Forgot,
  SettingPage_QueryType_Page_Privacy,
  SettingPage_QueryType_Page_Disclaimer
} from "./js/fireGodsDeclare";
import MyCkEditor from "@/taylorCommon/component/MyCkEditor.vue";
import FileUploadButton from "@/taylorCommon/component/FileUploadButton.vue";
import Vue from "vue";

export default {
  components: {FileUploadButton, MyCkEditor},
  data: function () {
    return {
      datas:[
        {
          settingQueryType:SettingPage_QueryType_Index,
          title:"頁面-首頁-標題",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:SettingPage_QueryType_About,
          title:"頁面-道場簡介-標題",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:SettingPage_QueryType_Event,
          title:"頁面-(問事諮商/財神諮商/祈福法會)-標題",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType: SettingPage_QueryType_Sign,
          title: "頁面-灶君靈籤-標題",
          uitype: "text",
          value: "",
        },
        {
          settingQueryType: SettingPage_QueryType_BookingStep1,
          title: "頁面-點燈步驟一 標題",
          uitype: "text",
          value: "",
        },
        {
          settingQueryType: SettingPage_QueryType_BookingStep2,
          title: "頁面-點燈步驟二 標題",
          uitype: "text",
          value: "",
        },
        {
          settingQueryType: SettingPage_QueryType_BookingStep3,
          title: "頁面-點燈步驟三 標題",
          uitype: "text",
          value: "",
        },
        {
          settingQueryType: SettingPage_QueryType_BookingStep4,
          title: "頁面-點燈步驟四 標題",
          uitype: "text",
          value: "",
        },
        {
          settingQueryType: SettingPage_QueryType_BookingStep5,
          title: "頁面-點燈步驟五 標題",
          uitype: "text",
          value: "",
        },
        {
          settingQueryType: SettingPage_QueryType_OrderStep1,
          title: "頁面-訂單查詢 步驟一 標題",
          uitype: "text",
          value: "",
        },
        {
          settingQueryType: SettingPage_QueryType_OrderStep2,
          title: "頁面-訂單查詢 步驟一 標題",
          uitype: "text",
          value: "",
        },
        {
          settingQueryType: SettingPage_QueryType_OrderStep3,
          title: "頁面-訂單查詢 步驟一 標題",
          uitype: "text",
          value: "",
        },
        {
          settingQueryType:SettingPage_QueryType_Ebooks,
          title:"頁面-道堂出版-標題",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:SettingPage_QueryType_Page_ProductList,
          title:"頁面-文新道場-文創商品-標題",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:SettingPage_QueryType_Page_ProductDetail,
          title:"頁面-文新道場-商品-標題",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:SettingPage_QueryType_Page_Register,
          title:"頁面-文新道場-註冊會員-標題",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:SettingPage_QueryType_Page_Login,
          title:"頁面-文新道場-登入會員-標題",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:SettingPage_QueryType_Page_Forgot,
          title:"頁面-文新道場-忘記密碼-標題",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:SettingPage_QueryType_Page_Privacy,
          title:"頁面-文新道場-隱私權政策-標題",
          uitype:"text",
          value:"",
        },
        {
          settingQueryType:SettingPage_QueryType_Page_Disclaimer,
          title:"頁面-文新道場-免責聲明-標題",
          uitype:"text",
          value:"",
        },

      ],
      datasTemplate:[
        {
          settingQueryType:"",
          title:"",
          uitype:"",
          value:"",
        },
      ],
    };
  },
  methods: {
    async loadData() {
      let settingValue="";

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_Index);
      this.datas[0].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_About);
      this.datas[1].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_Event);
      this.datas[2].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_Sign);
      this.datas[3].value=settingValue.data.data;



      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_BookingStep1);
      this.datas[4].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_BookingStep2);
      this.datas[5].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_BookingStep3);
      this.datas[6].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_BookingStep4);
      this.datas[7].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_BookingStep5);
      this.datas[8].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_OrderStep1);
      this.datas[9].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_OrderStep2);
      this.datas[10].value=settingValue.data.data;
      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_OrderStep3);
      this.datas[11].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_Ebooks);
      this.datas[12].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_Page_ProductList);
      this.datas[13].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_Page_ProductDetail);
      this.datas[14].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_Page_Register);
      this.datas[15].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_Page_Login);
      this.datas[16].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_Page_Forgot);
      this.datas[17].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_Page_Privacy);
      this.datas[18].value=settingValue.data.data;

      settingValue=await apiAdmin.api_admSetting_GetValueOrDefault(SettingPage_QueryType_Page_Disclaimer);
      this.datas[19].value=settingValue.data.data;


    },
    submit(item){
      apiAdmin.api_admSetting_Save(item.settingQueryType,item.value).then((data)=>{
        alert('儲存成功');
      })
    },
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    uploadSuccess(image,result){
      if (result && result.data.FileCount>0){
        image.value=result.data.FileUrls[0]
      }else{
        alert("檔案上傳失敗")
      }
    },



  },
  mounted() {
    this.loadData();
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
